import React from 'react'
import { ButtonGroup, Icon, Position, Tooltip } from '@blueprintjs/core'
import { Navigate, Views, View, ToolbarProps } from 'react-big-calendar'
import { AppointmentCalendarSelector } from './appointment-calendar-selector'
import { CalendarEvent } from './types'
import { Button } from 'browser/components/atomic-elements/atoms/button/button'

import './_appointment-toolbar.scss'

interface AppointmentToolbarProps extends ToolbarProps<CalendarEvent, object> {
  onCalendarsSelected: (calendarIds: Record<string, boolean>) => void
  onCreateStandingAppointment: () => void
  showCalendarFilter?: boolean
  showStandingAppointmentCreation?: boolean
}

export const AppointmentToolbar: React.FC<AppointmentToolbarProps> = React.memo(
  ({
    label,
    view,
    views,
    onView,
    onNavigate,
    onCalendarsSelected,
    onCreateStandingAppointment,
    showCalendarFilter,
    showStandingAppointmentCreation,
  }) => {
    const viewLabels: Record<string, string> = {
      [Views.MONTH]: 'Month',
      [Views.WEEK]: 'Week',
      [Views.DAY]: 'Day',
      [Views.AGENDA]: 'Agenda',
      resource: 'Resources',
    }

    const viewArray = Array.isArray(views)
      ? views
      : (Object.keys(views).filter((k) => views[k as keyof typeof views]) as View[])

    return (
      <div className="appointment-toolbar">
        <ButtonGroup>
          <Button buttonText="Today" onClick={() => onNavigate(Navigate.TODAY)} />
          <Button onClick={() => onNavigate(Navigate.PREVIOUS)}>
            <Icon icon="chevron-left" />
          </Button>
          <Button onClick={() => onNavigate(Navigate.NEXT)}>
            <Icon icon="chevron-right" />
          </Button>
        </ButtonGroup>

        <span className="appointment-toolbar-label">{label}</span>

        <ButtonGroup className="u-bumperLeft">
          {viewArray.map((viewName) => (
            <Button
              key={viewName}
              buttonText={viewLabels[viewName] || viewName}
              isActive={view === viewName}
              onClick={() => onView(viewName)}
            />
          ))}
        </ButtonGroup>

        {(showStandingAppointmentCreation || showCalendarFilter) && (
          <ButtonGroup className="u-bumperLeft">
            {showStandingAppointmentCreation && (
              <Tooltip content="Create Standing Appointment" position={Position.TOP}>
                <Button onClick={onCreateStandingAppointment}>
                  <Icon icon="plus" />
                </Button>
              </Tooltip>
            )}
            {showCalendarFilter && (
              <Tooltip content="Filter Calendars" position={Position.TOP}>
                <AppointmentCalendarSelector onCalendarsSelected={onCalendarsSelected} />
              </Tooltip>
            )}
          </ButtonGroup>
        )}
      </div>
    )
  }
)
